import React from 'react'
import PropTypes from 'prop-types'
import { XIcon } from '@heroicons/react/outline'
import classNames from 'classnames'
import { Link } from 'react-router-dom'

function AnnouncementBanner({
  show = true,
  message = '',
  longMessage = '',
  ctaText = 'Learn more',
  onClose = () => {}
}) {
  return (
    <div
      className={classNames('sticky top-0 z-10 transition duration-200 ease-in-out', {
        'mt-0 translate-y-0': show,
        '-mt-24 md:-mt-12 -translate-y-full': !show
      })}
    >
      <div className="bg-purple-800 dark:bg-purple-800">
        <div className="px-3 py-2 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="flex items-start justify-between gap-3 md:items-center md:justify-center">
            <div className="flex-1 md:flex-none md:text-center">
              <p className="text-sm font-medium text-white md:text-base">
                <span className="md:hidden">{message}</span>
                <span className="hidden md:inline">{longMessage || message}</span>
                {ctaText && (
                  <Link
                    to="/support/handling_lts_registrations"
                    className="mt-1 block font-bold text-white underline hover:text-purple-200 md:mt-0 md:ml-2 md:inline-block"
                  >
                    {ctaText} <span aria-hidden="true">&rarr;</span>
                  </Link>
                )}
              </p>
            </div>
            <button
              type="button"
              className="flex-shrink-0 p-1 rounded-md hover:bg-purple-500 dark:hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-white"
              onClick={onClose}
            >
              <span className="sr-only">Dismiss</span>
              <XIcon className="w-5 h-5 text-white md:w-6 md:h-6" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

AnnouncementBanner.propTypes = {
  show: PropTypes.bool,
  longMessage: PropTypes.string,
  message: PropTypes.string,
  ctaText: PropTypes.string,
  onClose: PropTypes.func
}

export default AnnouncementBanner
